<template>
  <div>
    <AppLayout>
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </AppLayout>
  </div>
</template>

<script setup>
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'

const route = useRoute()
const router = useRouter()

watch(
  () => route.path,
  async (newPath) => {
    if (!document.startViewTransition) return
    document.documentElement.classList.add('view-transition')
    await document.startViewTransition(async () => {
      await router.push({ 
        path: newPath,
        query: { ...route.query }
      })
    }).finished
    document.documentElement.classList.remove('view-transition')
  }
)
</script>

<style>

::view-transition-old(root) {
  animation: 350ms ease-out both blur-out;
}

::view-transition-new(root) {
  animation: 350ms ease-out both blur-in;
}

@keyframes blur-out {
  from {
    opacity: 1;
    filter: blur(0);
  }
  to {
    opacity: 0.9;
    filter: blur(1px);
  }
}

@keyframes blur-in {
  from {
    opacity: 0.9;
    filter: blur(1px);
  }
  to {
    opacity: 1;
    filter: blur(0);
  }
}
header{
   view-transition-name: header;
}

html{
  background: var(--lightgrey);
  transition: 500ms;
  overflow: hidden scroll;
}


* {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
  color: #000;
}

:root {
  --green: green;
  --white: #fff;
  --black: #222222;
  --grey: #f6f6f6;
  --blackgrey: #cfcfcf;
  --blue: #222;
  --red: #222;
  --boxshadowhover: 0px 0px 20px 0px rgb(0 0 0 / 23%);
  --boxshadowlight: 0 20px 27px 0 rgb(0 0 0 / 5%);
  --boxclick:0px 2px 10px 2px #12323e;
  --boxerror:0px 0px 5px 1px #fe6b58;
  --boxgoord:0px 0px 5px 1px green;
  --light: #fbf8f4;
  --lightgrey: #f8f8f9;
  --lightblue: #88989e;
  --input: #efefef;
}

:root.dark-theme {
  --green: green;
  --white: #222225;
  --input: #222225;
  --black: #a9a9b2;
  --grey: #f6f6f6;
  --blackgrey: #cfcfcf;
  --blue: #a2a5b9;
  --red: #fe6b58;
  --boxshadowhover: 0px 0px 20px 0px rgb(0 0 0 / 23%);
  --boxerror:0px 0px 5px 1px #fe6b58;
  --boxgoord:0px 0px 5px 1px green;
  --light: #262626;
  --lightgrey: #3c3a40;
  --lightblue: #88989e;
}


button{
  font-family: 'mon';
}

.button{
    background: var(--blue);
    color: var(--white);
    text-align: center;
    font-size: 14px;
    padding: 5px;
    font-weight: 400;
    transition: 200ms;
    min-height: calc(60px - 20px);
    display: grid;
    align-items: center;
    font-family: 'mon';
    border-radius: 10px;
}

.clickbutton{
  transition: 200ms;
}
.clickbutton:active{
  box-shadow: var(--boxclick);
  opacity: 0.5;
}


.button_red{
  background: var(--red);
  color: var(--white)
}

.button_blue{
  background: var(--black);
  color: var(--white)
}

.button_light{
  border: 1px solid var(--blackgrey);
  background: var(--white);
}

.buttons{
    text-align: center;
    padding: 10px 5px;
    width: calc(100% - 10px);
    transition: 500ms;
    text-transform: uppercase;
    font-family: 'mon';
    border-radius: 10px;
}
.buttons p{
       font-size: 18px;
       font-weight: 300;
       color: var(--white);
}
.buttons span {
    font-size: 18px;
    font-weight: 100;
    color: var(--white);
}

.titles{
    font-weight: 300;
    font-size: 18px;
    color: var(--blue);
}


.nocopy{
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.centeproduct{
  text-align: center;
  margin: 20px 0px;
}

.cuscheck{
    display: grid;
    align-items: center;
    justify-items: center;
    width: 20px;
    height: 20px;
}

.cuscheck input[type='checkbox']:checked {
  background-color: var(--black);
}
.cuscheck input[type='checkbox']:checked:after {
    content: '\2713';
    color: white;
    font-size: 30px;
    position: absolute;
    margin-top: -17px;
    margin-left: -10px;
}
.cuscheck input[type='checkbox']{
  text-align: center;
  appearance:none;
  border: 1px solid var(--black);
  box-shadow: none;
  margin-bottom: 0px;
}
.bold{
  font-weight: 300;
    color: var(--black);
    font-size: 18px;
}
.nodisplay{
  display: none;
}
.customCheckbox{
    border: 1px solid #C4C4C4;
    width: 70px;
    height: 30px;
    border-radius: 50px;
    background: #F3F5F7;
    overflow: hidden;
    transition: 500ms;
    margin: 5px 0px;
}

.customCheckbox:after{
    content: '';
    width: 30px;
    height: 30px;
    display: block;
    background: #A8AEB0;
    border-radius: 100%;
    transition: 500ms;
}

.customCheckboxActivity:after{
    background: var(--black);
    transform: translateX(40px);
}

.activityButton{
    opacity: 1;
}

</style>
